import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@accio3d/shared-ui/components/custom/sentry';
import '@accio3d/design-system/styles/base.css';
import { App } from './app';
import { PostHogProvider } from './utils/posthog';

initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_RELEASE,
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <PostHogProvider>
      <App />
    </PostHogProvider>
  </StrictMode>,
);
